<template>
  <div
    v-if="showVersion === 'grid'"
    class="border group rounded-2xl overflow-hidden shadow-lg lg:h-72 hover:cursor-pointer"
    @click="goToActivity(activity.slug)"
    v-motion="{ initial: { opacity: 0, scale: 0.8 }, visible: { opacity: 1, scale: 1 } }"
    transition="{ delay: index * 0.2, duration: 0.8 }"
  >
 <img
  :src="activity.vignette"
  :alt="activity.seo.meta_title || 'Activity Cover'"
  width="800"
  height="300"
  class="w-full h-48 object-cover transition duration-300 group-hover:scale-110"
/>
    <div class="p-4">
      <h3 class="text-lg ltr:text-left font-semibold" v-if="currentLanguage==='ar'">
        {{ activity.title_ar }}
      </h3>
      <h3 class="text-lg ltr:text-left font-semibold" v-if="currentLanguage==='ru'">
        {{ activity.title_ru }}
      </h3>
                            <template v-if="currentLanguage === 'zh'">
                       <h3>{{ activity.title_zh }}</h3> 
                      </template>
                      <template v-if="currentLanguage === 'ja'">
                       <h3>{{ activity.title_ja }}</h3> 
                      </template>
                      <template v-if="currentLanguage === 'ko'">
                        <h3>{{ activity.title_ko }}</h3> 
                      </template>
      <h3 class="text-lg ltr:text-left font-semibold" v-if="currentLanguage==='fr'">{{ activity.title }}</h3>
      <h3 class="text-lg ltr:text-left font-semibold" v-if="currentLanguage==='en'">{{ activity.title_en }}</h3>
      <p class="text-gray-600 ltr:text-left truncate">
        <i class="fas fa-map-marker-alt text-blue mr-2"></i>
        <span v-if="currentLanguage==='ar'">{{ activity.address_ar }}</span>
        <span v-if="currentLanguage==='ru'">{{ activity.address_ru }}</span>
        <span v-if="currentLanguage==='fr'">{{ activity.address }}</span>
        <span v-if="currentLanguage==='en'">{{ activity.address_en }}</span>
                              <template v-if="currentLanguage === 'zh'">
                        {{ activity.address_zh }}
                      </template>
                      <template v-if="currentLanguage === 'ja'">
                        {{ activity.address_ja }}
                      </template>
                      <template v-if="currentLanguage === 'ko'">
                        {{ activity.address_ko}}
                      </template>
      </p>
    </div>
  </div>
  <div
    v-if="showVersion === 'list'"
    class="block border group rounded-2xl overflow-hidden shadow-lg hover:cursor-pointer"
    @click="goToActivity(activity.slug)"
  >
    <div class="grid grid-cols-4">
      <div
        class="col-span-1 relative w-full h-full bg-no-repeat bg-cover grow flex flex-col-reverse pb-6 lg:pb-10 transition duration-300 group-hover:scale-110"
        :style="{
          backgroundImage: `url(${activity.vignette})`,
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }"
      ></div>

      <div class="col-span-3">
        <div class="flex flex-col justify-between p-4">
          <div class="flex flex-col">
            <h3 class="font-semibold text-lg flex items-start" v-if="currentLanguage==='ar'">
              {{ activity.title_ar }}
            </h3>
            <h3 class="font-semibold text-lg flex items-start" v-if="currentLanguage==='ru'">
              {{ activity.title_ru }}
            </h3>
            <h3 class="font-semibold text-lg flex items-start" v-if="currentLanguage==='en'">
              {{ activity.title_en }}
            </h3>   
            <h3 class="font-semibold text-lg flex items-start" v-if="currentLanguage==='fr'">
              {{ activity.title }}
            </h3>
                                        <template v-if="currentLanguage === 'zh'">
                       <h3>{{ activity.title_zh }}</h3> 
                      </template>
                      <template v-if="currentLanguage === 'ja'">
                       <h3>{{ activity.title_ja }}</h3> 
                      </template>
                      <template v-if="currentLanguage === 'ko'">
                        <h3>{{ activity.title_ko }}</h3> 
                      </template>   
          </div>

          <div class="flex justify-between">
            <div class="flex items-end">
              <div class="flex items-center mt-1" v-if="activity.end_data">
                <span>
                  <i class="fas fa-calendar text-blue mr-1"></i>
                  {{ activity.end_date }}
                </span>
              </div>
              <div class="flex items-center text-gray-600 text-sm ">
                <i class="fas fa-map-marker-alt text-[#194032] mr-1 truncate"></i>
                <span>        
                  <span  v-if="currentLanguage==='ar'">{{ activity.address_ar }}</span>
                  <span  v-if="currentLanguage==='ru'">{{ activity.address_ru }}</span>

        <span v-if="currentLanguage==='fr'">{{ activity.address }}</span>
        <span v-if="currentLanguage==='en'">{{ activity.address_en }}</span>
                        <span  v-if="currentLanguage==='zh'">{{ activity.address_zh }}</span>

        <span v-if="currentLanguage=== 'ja'">{{ activity.address_ja }}</span>
        <span v-if="currentLanguage=== 'ko'">{{ activity.address_ko }}</span>
      
      </span>
        
              </div>
            </div>
            <div>
              <div class="">
                <i class="fas fa-user text-blue mr-1"></i>
                {{ activity.numberplaces }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activity: {
      type: Object,
      required: true,
    },
    showVersion: {
      type: String,
      default: "grid",
    },
  },
  data(){
    return{
      currentLanguage: this.$i18n.locale,
    }
  },
  watch: {
    '$i18n.locale'(newLocale) {
      this.currentLanguage = newLocale;
    },
  },
  methods: {
    goToActivity(id) {
      this.$router.push({ path: `/activity/${id}` });
    },
  },
};
</script>
